module.exports = __webpack_public_path__ + "img/product-5.929f1443.png";